module.exports = __webpack_public_path__ + "static/img/gaoxiongerchang.92f1862.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gaoxiongerchang.jpg
// module id = tsHl
// module chunks = 1